import React from 'react';

import { MCText, ToggleSwitch } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

class Subscription extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    return (
      <div className={'mc-setting-change-pw'}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.notifications)}</div>
        </div>
        <div className={'mc-form mc-flex'}>
          <div className={'mc-flex-30 mc-mlr30 mc-mtb10'}>
            <MCText label={LANG_CONST.email_subscriptions} size={20} heading />
            <ToggleSwitch
              checked={model.state.email_subscription !== false}
              onChange={(e) => {
                e.preventDefault();
                e.stopPropagation();
                model.emailSubscription();
              }}
            />
          </div>
          <div className={'mc-flex-30 mc-mlr30 mc-mtb10'}>
            <MCText label={LANG_CONST.webpush_subscriptions} size={20} heading />
            <ToggleSwitch
              checked={
                model.state.desktopAlerts !== false && window.Notification?.permission === 'granted'
              }
              onChange={(e) => {
                e.preventDefault();
                model.webpushSubscription();
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Subscription;
